module.exports = {
      id: "google-play-usage",
      viewBox: undefined,
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#google-play",
      toString: function () {
        return this.url;
      }
    }